var map = {
	"./bsg-table.jpg": 529,
	"./download-button.svg": 194,
	"./icon_bombed.png": 301,
	"./icon_dashmate.png": 699,
	"./icon_gamemate.png": 848,
	"./icon_soapstone.png": 506,
	"./icon_tap-stacks.png": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;